module.exports = __webpack_public_path__ + "static/img/about13.8979cb78.png";